<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <v-layout row class="mr-1 ml-2 mt-1">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> sort </v-icon>
          </v-avatar>
          Work Activity
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon>
            {{this.getTransitions.flow[this.getTransitions.flow.length - 1].icon}}
          </v-icon>
          </v-avatar>
          {{this.getTransitions.flow[this.getTransitions.flow.length - 1].title}}
        </v-chip>
      </v-layout>
      <v-layout row :class="ui.textSubheading">
        <v-flex xs11 offset-xs1>
          <div class="ml-2">
            {{this.getDetailBasic.title}}
          </div>
        </v-flex>
      </v-layout>
      <v-layout row class="mr-1 ml-2 mt-1">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> emoji_transportation </v-icon>
          </v-avatar>
          Asset
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> fingerprint </v-icon>
          </v-avatar>
          {{getDetail.link.aid}}
        </v-chip>
      </v-layout>
      <v-layout row class="mr-1 ml-2 mt-1">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> title </v-icon>
          </v-avatar>
          {{getDetail.link.at}}
        </v-chip>
        <v-spacer/>
      </v-layout>
      <v-layout row class="mr-1 ml-2 mt-4">
        <v-spacer/>
        <v-chip :color="ui.chipColor" :text-color="ui.textColor">
          <v-icon left :color="ui.btnColor"> grid_view </v-icon>
            <div :class="ui.textSubheadingBold">
              {{getDetailChar.type}}
            </div>
        </v-chip>
        <v-chip :color="ui.chipColor" :text-color="ui.textColor">
          <v-icon left :color="ui.btnColor"> priority_high </v-icon>
            <div :class="ui.textSubheadingBold">
              {{getDetailChar.pri}}
            </div>
        </v-chip>
        <v-chip :color="ui.chipColor" :text-color="ui.textColor"
        v-if="getDetailChar.comp !== ''">
          <v-icon left :color="ui.btnColor"> assured_workload </v-icon>
            <div :class="ui.textSubheadingBold">
              {{getDetailChar.comp}}
            </div>
        </v-chip>
      </v-layout>
      <v-layout row class="mr-2 mb-2">
        <v-spacer/>
        <v-chip :color="ui.chipColor" :text-color="ui.textColor"
        class="hidden-xs-only">
          <v-icon left :color="ui.btnColor"> today </v-icon>
            <div :class="ui.textSubheadingBold">
              {{dateTypeA(this.getDetail.stats.ddue)}}
            </div>
        </v-chip>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> person </v-icon>
          </v-avatar>
          {{getDetailRelps.h5.length}}
        </v-chip>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> category </v-icon>
          </v-avatar>
          {{getDetailRelps.l5.length}}
        </v-chip>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> article </v-icon>
          </v-avatar>
          {{getDetailRelps.o5.length}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2">
        <div :class="ui.textSubheading">
          {{getDetail.char.scope}}
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme, numberFunctions, dateFunctions],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailLink",
      "getTransitions",
      "getDetailRelps"
    ]),
    transTitle() {
      let flow = this.getTransitions.flow;
      let title = flow[flow.length - 1].title;
      return title;
    },
    transIcon() {
      let flow = this.getTransitions.flow;
      let icon = flow[flow.length - 1].icon;
      return icon;
    }
  }
};
</script>
